import CoreInstance from 'api/CoreInstance';
import { localeFlag, getHeadersWithTokens } from 'api/ApiHelpers';
import { isTeacher } from 'lib/helpers';
import ClientInstance from 'api/ClientInstance';
import { IGroupsByCentersParams } from 'hooks/resources/useGroupsByCenters';

interface IgroupEndpoints {
  deleteGroupAsOwnerAdmin?: any;
  deleteGroupAsTeacher?: any;
  getCenterConfiguration?: any;
  getGroup?: any;
  getGroupAsShared?: any;
  getGroupsAsTeacher?: any;
  getGroupDetail?: any;
  getGroupDetailAsShare?: any;
  getGroups?: any;
  getGroupsByCenterAsOwner?: any;
  getGroupsByCenterId?: any;
  getOrgConfiguration?: any;
  postAssignBabiesToGroup?: any;
  postGroup?: any;
  postGroupAsTeacher?:any;
  postGroupAsShared?: any;
  postGroupByCenterId?: any;
  postScheduleActivity?: any;
  putGroup?: any;
  putGroupAsShared?: any;
  putGroupByCenterId?: any;
  putGroupFinishDay?: any;
  putGroupProgress?: any;
  getGroupsByCenterAsAdmin?: any;
  getGroupsByCenterAsTeacher?: any;
  getGroupsByCenterAsOwnerAdmin?: any;
  getGroupsTeacherAsAdmin?: any;
  getGroupsTeacherAsTeacher?: any;
  putAvatarAsTeacher: (groupId: number, centerId: number, body: any) => Promise<any>;
  putAvatar: (groupId: number, centerId: number, body: any) => Promise<any>;
  getGroupAsOwnerAdminDirector: (centerId: number, groupId: number) => Promise<any>;
  getGroupsByCenters: (params: IGroupsByCentersParams) => Promise<any>;
}

const groupEndpoints: IgroupEndpoints = {
  deleteGroupAsTeacher: (groupId: number) => ClientInstance.delete(`/centers/shared/groups/${groupId}?${localeFlag()}`),
  deleteGroupAsOwnerAdmin: (centerId: number, groupId: number, userRole:string) => ClientInstance.delete(`/organizations/${userRole}/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
  getCenterConfiguration: () => CoreInstance.get(`/centers/center_configuration?${localeFlag()}`, getHeadersWithTokens(true)),
  getGroup: (groupId: number) => CoreInstance.get(`/centers/groups/${groupId}?${localeFlag()}`, getHeadersWithTokens(true)),
  getGroupAsOwnerAdminDirector: (centerId: number, groupId: number) => CoreInstance.get(`/organizations/centers/${centerId}/groups/${groupId}`, getHeadersWithTokens()),
  getGroupAsShared: () => ClientInstance.get('/centers/shared/groups', getHeadersWithTokens(true)),
  getGroupDetail: (groupId: any) => CoreInstance.get(`/centers/groups/${groupId}`, getHeadersWithTokens(true)),
  getGroupDetailAsShare: (centerId: number, groupId: number) => ClientInstance.get(`/organizations/shared/centers/${centerId}/groups/${groupId}`, getHeadersWithTokens(true)),
  getGroups: () => CoreInstance.get(`/centers/groups?${localeFlag()}`, getHeadersWithTokens(true)),
  getGroupsAsTeacher: (centerId: number) => ClientInstance.get(`/centers/shared/centers/${centerId}/teachers/groups`, getHeadersWithTokens(true)),
  getGroupsByCenterAsOwner: (centerId: number) => ClientInstance.get(`/organizations/owners/centers/${centerId}/groups`),
  getGroupsByCenterAsAdmin: (centerId: number) => ClientInstance.get(`/organizations/admins/centers/${centerId}/groups`),
  getGroupsByCenterId: (centerId: number) => CoreInstance.get(`/organizations/centers/${centerId}?${localeFlag()}`, getHeadersWithTokens()), // Used to get Public Id for classrooms
  getGroupsByCenterAsTeacher: (centerId?: number) => CoreInstance.get(`/centers/groups`, getHeadersWithTokens()),
  getGroupsByCenterAsOwnerAdmin: (centerId: number) => ClientInstance.get(`/organizations/shared/centers/${centerId}/groups`),
  getGroupsTeacherAsTeacher: (centerId: number, groupId: number) => ClientInstance.get(`/centers/shared/centers/${centerId}/groups/${groupId}/teachers`),
  getGroupsTeacherAsAdmin: (centerId:number, groupId: number) => ClientInstance.get(`/organizations/shared/centers/${centerId}/groups/${groupId}/teachers`),
  getOrgConfiguration: () => CoreInstance.get(`/organizations/organization/organization_configuration?${localeFlag()}`, getHeadersWithTokens(false)),
  postAssignBabiesToGroup: (groupId: number, body: any) => CoreInstance.post(`/centers/groups/${groupId}/assign_babies?${localeFlag()}`, body, getHeadersWithTokens(true)),
  postGroup: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/groups?${localeFlag()}`, body),
  postGroupAsTeacher: (body: any) => ClientInstance.post(`/centers/shared/groups?${localeFlag()}`, body),
  postGroupAsShared: (body: any) => ClientInstance.post('/centers/shared/groups', body, getHeadersWithTokens(true)),
  postGroupByCenterId: (centerId: number, body: any) => CoreInstance.post(`/organizations/centers/${centerId}/groups?${localeFlag()}`, body, getHeadersWithTokens(true)),
  putGroup: (groupId: number, centerId:number, body: any) => ClientInstance.put(`/centers/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`, body, getHeadersWithTokens(true)),
  postScheduleActivity: (body: any) => CoreInstance.post(isTeacher() ? `/centers/daps?${localeFlag()}` : `/organizations/daps?${localeFlag()}`, body, getHeadersWithTokens(isTeacher())),
  putGroupAsShared: (groupId: number, centerId:number, body: any) => ClientInstance.put(`organizations/shared/centers/${centerId}/groups/${groupId}`, body, getHeadersWithTokens(true)),
  putGroupByCenterId: (centerId: number, groupId: number, body: any) => CoreInstance.put(`/organizations/centers/${centerId}/groups/${groupId}?${localeFlag()}`, body, getHeadersWithTokens(true)),
  putGroupFinishDay: (groupId: number, body: any) => CoreInstance.put(`/centers/groups/${groupId}/finish_day?${localeFlag()}`, body, getHeadersWithTokens(true)),
  putGroupProgress: (groupId: number, body: any) => CoreInstance.put(`/centers/groups/${groupId}/update_progress?${localeFlag()}`, body, getHeadersWithTokens(true)),

  putAvatar: (groupId: number, centerId: number, body: any) => ClientInstance.put(`/organizations/admins/centers/${centerId}/groups/${groupId}/add_logo`, body, getHeadersWithTokens()),
  putAvatarAsTeacher: (groupId: number, centerId: number, body: any) => ClientInstance.put(`/centers/shared/centers/${centerId}/groups/${groupId}/add_logo`, body, getHeadersWithTokens(true)),

  getGroupsByCenters: (params: any) => CoreInstance.get(`centers/groups_centers`, {
    ...getHeadersWithTokens(true), ...{ params }
  }),
};

export default groupEndpoints;
